import React, {Component} from 'react';
import {Form} from 'react-bootstrap';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Facebook, Flag, Github, Linkedin, Twitter} from '../Redux/action';
import {connect} from 'react-redux';
import ImageTab from "./ImageTab";
import {FormattedMessage} from "react-intl";

class SocialTab extends Component {

	handleFlag = () => {
		if (this.props.name === ''&& this.props.email === '' && this.props.jobTitle === '' &&
			this.props.department === '' && this.props.mobile === '' && this.props.website === ''&&
			this.props.linkedin1 === '' && this.props.facebook1 === '' && this.props.twitter1 === '' &&
			this.props.github1 === '') {
			this.props.flag(false)
		}
	}


	async setLinkedinLink (event) {
		event.persist();
		await this.props.linkedin(event.target.value);
		if (event.target.value === '') {
			this.handleFlag();
		} else
			this.props.flag(true)
	};
	async setTwitterLink (event) {
		event.persist();
		await this.props.twitter(event.target.value);
		if (event.target.value === '') {
			this.handleFlag();
		} else
			this.props.flag(true)
	};
	async setFacebookLink (event) {
		event.persist();
		await this.props.facebook(event.target.value);
		if (event.target.value === '') {
			this.handleFlag();
		} else
			this.props.flag(true)
	};
	async setGithubLink (event) {
		event.persist();
		await this.props.github(event.target.value);
		if (event.target.value === '') {
			this.handleFlag();
		} else
			this.props.flag(true)
	};

	render() {
		return (

				<Form className="justify p-1 ">
					<label> <FormattedMessage id="image.upload"/></label>
					<ImageTab/>
					<br/>
					<Form.Group controlId="formGroupLinkedIn">
						<FontAwesomeIcon className={'mr-1'} icon={['fab', 'linkedin']}/>
						<Form.Label>LinkedIn</Form.Label>
						<Form.Control type="url" onChange={this.setLinkedinLink.bind(this)} value={this.props.linkedin1}  placeholder="https://www.linkedin.com"/>
					</Form.Group>
					<Form.Group controlId="formGroupTwitter">
						<img className={'mr-1'} style={{width: '14px'}} src={`${process.env.PUBLIC_URL}/x.svg`} alt={'X'}/>
						<Form.Label>X</Form.Label>
						<Form.Control type="url" onChange={this.setTwitterLink.bind(this)} value={this.props.twitter1}  placeholder="https://x.com"/>
					</Form.Group>
					<Form.Group controlId="formGroupFacebook">
						<FontAwesomeIcon className={'mr-1'} icon={['fab', 'facebook']}/>
						<Form.Label>Facebook</Form.Label>
						<Form.Control type="url" onChange={this.setFacebookLink.bind(this)} value={this.props.facebook1}  placeholder="https://www.facebook.com/"/>
					</Form.Group>
					{/* <Form.Group controlId="formGroupGithub">
						<FontAwesomeIcon className={'mr-1'} icon={['fab', 'github']}/>
						<Form.Label>Github</Form.Label>
						<Form.Control type="url" onChange={this.setGithubLink.bind(this)} value={this.props.github1}  placeholder="https://www.github.com/"/>
					</Form.Group> */}


				</Form>
		);
	}
}

function mapDispatchToProps(dispatch) {
	return {
		flag: (flag) => dispatch(Flag(flag)),
		linkedin: (linkedin) => dispatch(Linkedin(linkedin)),
		twitter: (twitter) => dispatch(Twitter(twitter)),
		facebook: (facebook) => dispatch(Facebook(facebook)),
		github: (github) => dispatch(Github(github)),
	};
}

function mapStateToProps(state) {
	return {

		name: state.ArabicReducer.ar_name,
		email: state.ArabicReducer.ar_email,
		jobTitle: state.ArabicReducer.ar_jobTitle,
		department: state.ArabicReducer.ar_department,
		mobile: state.ArabicReducer.ar_mobile,
		website: state.ArabicReducer.ar_website,
		linkedin1: state.socialReducer.linkedin,
		twitter1: state.socialReducer.twitter,
		facebook1: state.socialReducer.facebook,
		github1: state.socialReducer.github,
	};
}


export default connect(mapStateToProps, mapDispatchToProps)(SocialTab);
